export const CircleArrow = (props: { className?: string; onClick?: () => void }) => {
    return (
        <div className={`CircleArrow ${props.className}`}>
            <svg width="10" height="12" viewBox="0 0 10 12" xmlns="http://www.w3.org/2000/svg">
                <path d="M0.278988 6.27871C0.278988 6.09266 0.372011 5.90661 0.465034 5.81359L5.1162 1.16243C5.39527 0.883358 5.86038 0.883358 6.13945 1.16243C6.41852 1.4415 6.41852 1.90661 6.13945 2.18568L1.95341 6.37173L6.13945 10.5578C6.41852 10.8368 6.41852 11.302 6.13945 11.581C5.86038 11.8601 5.39527 11.8601 5.1162 11.581L0.465034 6.92987C0.372011 6.55778 0.278988 6.37173 0.278988 6.27871Z" />
            </svg>
        </div>
    );
};
